module.exports = __webpack_public_path__ + "static/img/Logo1_NusaDuaBeachHotel.3018a94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo1_NusaDuaBeachHotel.png
// module id = 239
// module chunks = 1